// project-imports
import { getRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - DEVELOPMENT EVENTS ||============================== //

export async function handleDevelopmentEvents(action: APIAction) {
  switch (action.method) {
    case 'list':
      return getRequest(`/development-events?development-id=${action.id}&include-cancelled=true`);
    default:
      console.info('[ApiManager > handleApiAction > handleDevelopmentEvents] - Unknown method');
      break;
  }
}
